<script lang="ts">
  export let backgroundColor = '';
  export let title = '';
  export let description = '';
  export let customClass = '';
</script>

<section
  class="flex justify-center items-center px-8 text-white text-center {backgroundColor} h-[19rem] lg:h-[30rem] {customClass}"
>
  <div class="flex-col gap-4 lg:gap-6 lg:max-w-768">
    {#if title}
      <h1 class="text-display-md font-bold lg:text-display-2xl">
        {title}
      </h1>
    {/if}
    {#if description}
      <p class="text-lg lg:text-xxl lg:mt-6">{description}</p>
    {/if}
  </div>
</section>
